import { Stack, useTheme } from '@mui/material';
import { useModeTheme } from 'contexts/ModeThemeContext';
import React, { PropsWithChildren, useEffect, useRef } from 'react';
import { useQueryParams } from 'hooks';
import QueryKeys from 'api/queryKeys';
import { SSO_TEST_CALLBACK_EVENT_TYPE, SSO_TEST_CHANNEL } from 'consts';
import AppTopBar from '../AppTopBar';

const MainLayout: React.FC<PropsWithChildren> = ({ children = null }) => {
	const theme = useTheme();
	const { themeLoaded } = useModeTheme();
	const [ssoCallback] = useQueryParams(QueryKeys.ssoCallback);
	const [code] = useQueryParams(QueryKeys.code);
	const [error] = useQueryParams(QueryKeys.err);

	const sentRef = useRef(false);

	useEffect(() => {
		if (!ssoCallback || sentRef.current) return;
		sentRef.current = true;

		const channel = new BroadcastChannel(SSO_TEST_CHANNEL);
		channel.postMessage({
			type: SSO_TEST_CALLBACK_EVENT_TYPE,
			code: code || undefined,
			error: error || undefined
		});
		channel.close();
		window.close();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Stack
			direction="column"
			height="100%"
			sx={{
				fontFamily: 'DMSans, sans-serif',
				background: theme.palette.appBackground,
				transition: 'background-position 1500ms ease',
				backgroundSize: '300% 100%',
				backgroundPositionX: themeLoaded ? '100%' : '0'
			}}
			alignItems="center"
		>
			<AppTopBar />
			{children}
		</Stack>
	);
};

export default MainLayout;
